import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import DatePicker from "react-datepicker"; 
// import "react-datepicker/dist/react-datepicker.css";
// import "react-datetime/css/react-datetime.css";
import { ClearButton, Typeahead } from 'react-bootstrap-typeahead';
import { format } from 'date-fns';
import Datetime from 'react-datetime';
import {Form} from 'react-bootstrap';
// import DateTimePicker from 'react-widgets/lib/DateTimePicker'; 
// import { DateTimePicker } from 'react-widgets'; 

import DateTimePicker from 'react-datetime';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime/css/react-datetime.css";
// import moment from 'moment';
// import 'react-datetime/css/react-datetime.css';
import {getUserTimeZone} from '../../utils/userGroupUrlCheck';

import { getUserGroupData } from '../../utils/browserStorage';
import {timesheetFilterSkillsListAction,timesheetFilterCrewsListAction,timesheetFilterDepartmentsListAction,timesheetFilterEventsListAction, timesheetFilterLocationsListAction} from '../../actions/timesheetActions'; 
import * as types from '../../actions';
import { convertHHMMToDecimal } from '../../utils/commonUtilities';
import CustomMultiSelect from '../../components/commons/helpers/customMultiSelect';

import { LBL_SKILLS,LBL_DEPARTMENTS,LBL_LOCATION,LBL_CHOOSE_LOCATION,LBL_CREW,LBL_CHOOSE_CREW, LBL_EVENT, LBL_TITLE, LBL_CHECKIN_FROM_TIME, LBL_FROM_TIME, LBL_TO_TIME, LBL_CHECKOUT_FROM_TIME, LBL_SCHEDULED_HOURS, LBL_ACTUAL_HOURS, LBL_OT_HOURS, LBL_SELECT, LBL_SELECT_HOURS, LBL_CHECKIN_CHECKOUT, LBL_CHECKIN, LBL_CHECKOUT } from '../../configs/labelConfigs';
import { MSG_REQUIRED, MSG_FILTER_COMMON_ERROR } from '../../configs/msgConfigs';
import { ENUM_MM5 } from '../../configs/staticConfigs';
import {timeSheetDateHeader} from  '../../actions/commonActions';


import { findAllByDisplayValue } from '@testing-library/react';

class FilterTimesheet extends Component {

    constructor(props){
        super(props)
        this.state = { 
            selectedEventId: 0, 
            selectedEvent: [], 
            selectedCrew: [], 
            selectedLocation: [], 
            eventsOptions: [], 
            crewNameOptions: [],
            crewId:0, 
            locationOptions: [],
            locationId:0,
            departmentIds: [], 
            departmentData: [],
            skillIds: [], 
            skillData: [], 
            selCheckinCheckout: '',
            selectedFromDate: '',
            selectedToDate: '',
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            eventsListCalled:0, 
            selHoursType: '',
            startTime: '00:00', 
            endTime: '00:00',
            selectedStartDate: '',
            selectedEndDate: '',
            includeDate:true,
            dateValue:1,
            formErrors: {
                selectedFromDate:'',
                selectedToDate:'',         
                startTime: '',
                endTime: '',
                commonErr: ''
            }
        }
    }

    onSelectCheckinOut = (e) => {
        let {formErrors} = this.state; 
        formErrors.commonErr = ''; 
        this.setState({selCheckinCheckout:e.target.value,formErrors}) 
    } 

    onStartTimeChange = (time) => {
        let {formErrors} = this.state;    
        formErrors.startTime = '';
        formErrors.commonErr = ''; 
        let startTime = ''; 
        if(time._d !== undefined){
            startTime = format(new Date(time._d), 'HH:mm'); 
            this.setState({startTime,formErrors}); // ,endTime:startTime
        }
        else {
            this.setState({startTime,formErrors});
        }
    }

    onStartTimeBlur = (time) => {
        let {formErrors} = this.state;   
        formErrors.commonErr = '';  
        if(time._d !== undefined){
            let startTime = format(new Date(time._d), 'HH:mm');           
            formErrors.startTime = '';
            this.setState({startTime,formErrors}); // endTime:startTime
        }
        else{
            try{
                var d = new Date(),
                s = time,
                parts = s.match(/(\d+)\:(\d+)/),
                hours = (parseInt(parts[1].trim(), 10)),
                minutes = parseInt(parts[2].trim(), 10);

                d.setHours(hours);
                d.setMinutes(minutes);
                let startTime = format(d, 'HH:mm');
                formErrors.startTime = '';
                this.setState({startTime,formErrors}); // endTime:startTime
            }catch(err) {
                formErrors.startTime = MSG_REQUIRED;
                this.setState({formErrors});
            }
        }
    }
    
    onEndTimeChange = (time) => {
        let {formErrors} = this.state;  
        formErrors.commonErr = '';   
        formErrors.endTime = '';
        let endTime = ''; 
        if(time._d !== undefined){
            let endTime = format(new Date(time._d), 'HH:mm');    
            this.setState({endTime,formErrors});
        }
        else {
            this.setState({endTime,formErrors});
        }
    }

    onEndTimeBlur = (time) => {
        let {formErrors} = this.state;   
        formErrors.commonErr = '';  
        if(time._d !== undefined){
            let endTime = format(new Date(time._d), 'HH:mm');           
            formErrors.endTime = '';
            this.setState({endTime,formErrors});
        }
        else{
            try{
                var d = new Date(),
                s = time,
                parts = s.match(/(\d+)\:(\d+)/),
                hours = (parseInt(parts[1].trim(), 10)),
                minutes = parseInt(parts[2].trim(), 10);

                d.setHours(hours);
                d.setMinutes(minutes);
                let endTime = format(d, 'HH:mm');
                formErrors.endTime = '';
                this.setState({endTime,formErrors});
            }catch(err) {
                formErrors.endTime = MSG_REQUIRED;
                this.setState({formErrors});
            }
        }
    }

    onSelectHoursType = (e) => {
        let {formErrors} = this.state;   
        formErrors.commonErr = ''; 
        this.setState({selHoursType:e.target.value,formErrors}); 
    }

    handleEventChange = (selectedEvent) => {
        let {formErrors} = this.state;   
        formErrors.commonErr = ''; 
        let eventId = 0; 
        let selEvent = []; 
        if(selectedEvent.length>0){
            selEvent = selectedEvent; 
            eventId = selectedEvent[0].id; 
        } 
        this.setState({selectedEvent:selEvent, selectedEventId:eventId,formErrors});  
    }
    
    handleRemoveEvent = (e) => {
        if(e==='') {
            let eventId = 0; 
            let selEvent = []; 
            this.setState({selectedEvent:selEvent, selectedEventId:eventId}); 
        } 
    }
    handleCrewNameChange = (selectedCrew) => {
        let {formErrors} = this.state;   
        formErrors.commonErr = ''; 
        let crewId = 0; 
        let selCrew = []; 
        if(selectedCrew.length>0){
            selCrew = selectedCrew; 
            crewId = selectedCrew[0].id; 
        } 
        this.setState({selectedCrew:selCrew, crewId:crewId,formErrors});  
    }
    
    handleRemoveCrewName = (e) => {
        if(e==='') {
            let crewId = 0; 
            let selCrew = []; 
            this.setState({selectedCrew:selCrew, crewId:crewId}); 
        } 
    }
    handleLocationChange = (selectedLocation) => {
        let {formErrors} = this.state;   
        formErrors.commonErr = ''; 
        let locationId = 0; 
        let selLocation = []; 
        if(selectedLocation.length>0){
            selLocation = selectedLocation; 
            locationId = selectedLocation[0].id; 
        } 
        this.setState({selectedLocation:selLocation, locationId:locationId,formErrors});  
    }
    
    handleRemoveLocation = (e) => {
        if(e==='') {
            let locationId = 0; 
            let selLocation = []; 
            this.setState({selectedLocation:selLocation, locationId:locationId}); 
        } 
    }

    onDepartmentDataChange = (selectedData) =>{
        let selDep = []; 
        selectedData.forEach((item) => {
            selDep.push(item.value);
        });
        this.setState({ departmentIds:selDep });        
    }

    onSkillDataChange = (selectedData) =>{
        let selSkill = []; 
        selectedData.forEach((item) => {
            selSkill.push(item.value);
        });
        this.setState({ skillIds:selSkill });        
    }
    
    onDateFromChange = (date) =>{
        let formErrors = this.state.formErrors; 
        formErrors.selectedFromDate  = '';  
        formErrors.selectedToDate = ''; 
        formErrors.commonErr = ''; 
        let startDate = new Date(date);
        if(this.state.selectedToDate < startDate) {
            this.setState({selectedFromDate:startDate,selectedToDate:startDate,formErrors});    
        }
        else {
            this.setState({selectedFromDate:startDate,formErrors});    
        }
    }

    onDateToChange = (date) =>{ 
        let formErrors = this.state.formErrors; 
        formErrors.selectedFromDate  = '';  
        formErrors.selectedToDate = ''; 
        formErrors.commonErr = ''; 
        let endDate = new Date(date);
        this.setState({selectedToDate:endDate,formErrors});  
    }
    onStartDateChange = (date) =>{
        if(!date){
            date = this.props.defaultStartDate
        }
        let startDate = new Date(date);
        if(this.state.selectedEndDate < startDate) {
            this.setState({selectedStartDate:startDate,selectedEndDate:startDate},() => {
                this.props.setSelectedDate(this.state.selectedStartDate,this.state.selectedEndDate);
            });
        }
        else {
            this.setState({selectedStartDate:startDate});
            this.props.setSelectedDate(startDate,this.state.selectedEndDate);    
        }

        
    }

    onDateCheck = (e) => {
    this.setState({includeDate:!this.state.includeDate, dateValue:1-this.state.dateValue}) 
    }

    onEndDateChange = (date) =>{ 
        if(!date){
            date = this.props.defaultEndDate
        }
        let endDate = new Date(date);
        this.setState({selectedEndDate:endDate},() =>{
            this.props.setSelectedDate(this.state.selectedStartDate,this.state.selectedEndDate);
        });  
    }

    resetFilters = () => { 
        this.setState({ 
            selectedEventId: 0,
            crewId:0, 
            skillIds:[],
            locationId:0,
            departmentIds:[], 
            selectedEvent: [],
            selectedCrew:[],
            selectedLocation:[],
            skillData:[],
            departmentData:[], 
            selCheckinCheckout: '',
            selectedFromDate: '',
            selectedToDate: '',
            includeDate: true, 
            selectedStartDate: '',
            selectedEndDate: '',
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            selHoursType: '',
            startTime: '00:00', 
            endTime: '00:00',
            formErrors: {
                selectedFromDate:'',
                selectedToDate:'',         
                startTime: '',
                endTime: '',
                commonErr: ''
            }
        },() =>{
            let dataObj = {}; 
            this.props.timesheetFilterEventsListAction(dataObj);
            this.props.timesheetFilterSkillsListAction(); 
            this.props.timesheetFilterDepartmentsListAction(); 
            this.sendFilterData();
        }); 
        
    }

    sendFilterData = () => {
        // formErrors: { selectedFromDate:'', selectedToDate:'',  startTime: '', endTime: '' }
        let filtersSelected = 0; 
        let formErrors = this.state.formErrors; 
        let foundIssues = 0;

        // //CHECK ANY OF THE FILTER ITEM IS SELECTED
        // if(this.state.selectedEvent.length===0 && this.state.selCheckinCheckout==='' && this.state.selHoursType==='') {
        //     foundIssues = 1;
        //     formErrors.commonErr = MSG_FILTER_COMMON_ERROR; 
        // }

        // VALIDATE WHETHER FROM DATE IS GREATER THAN TO DATE - FOR BOTH CHECKIN AND CHECKOUT 
        let dateTimeFrom = new Date();
        let dateTimeTo   = new Date();
        if(this.state.selCheckinCheckout==='checkin' || this.state.selCheckinCheckout==='checkout') {
            dateTimeFrom = this.state.selectedFromDate;
            dateTimeTo = this.state.selectedToDate; 
            if(dateTimeFrom > dateTimeTo) {
                foundIssues = 1;
                formErrors.selectedToDate = MSG_REQUIRED;             
            }
        }  
        // VALIDATE WHETHER FROM TIME IS GREATER THAN TO TIME - FOR scheduled actual & over_time
        let selHoursType = 0; 
        let startTime = 0; 
        let endTime = 0; 
        if(this.state.selHoursType!='') {
            filtersSelected = 1; 
            selHoursType = this.state.selHoursType; 
            startTime = this.state.startTime.trim().length ? convertHHMMToDecimal(this.state.startTime) : 0; 
            endTime = this.state.endTime.trim().length ? convertHHMMToDecimal(this.state.endTime) : 0; 
            if(this.state.startTime.trim().length && this.state.endTime.trim().length && (parseFloat(startTime)==0 && parseFloat(endTime)==0) || (parseFloat(startTime) > 0 && parseFloat(endTime) > 0 && parseFloat(startTime)> parseFloat(endTime)) ) {
                foundIssues = 1;
                formErrors.endTime = MSG_REQUIRED;
            }
        }

        if(foundIssues > 0) {
            this.setState({formErrors});
            this.props.onShowFilterBy(); 
            return false; 
        }
        else {
            let arrEventIds = [];
            if(this.state.selectedEvent && this.state.selectedEvent.length) {
                this.state.selectedEvent.forEach(item => {
                    if(Number(item.id) > 0) {
                        arrEventIds.push(item.id);
                        filtersSelected = 1; 
                    }
                }) 
            }

            let in_out = -1; 
            if(this.state.selCheckinCheckout==='checkin')  in_out = 1; // 1: for checkin, 0: for checkout
            else if(this.state.selCheckinCheckout==='checkout') in_out = 0;

            let selectedFromDate = this.state.selectedFromDate; 
            let selectedToDate = this.state.selectedToDate;
            if(in_out>=0) { 
                // let timeZone =  getUserTimeZone(window.location);
                let defaultStartDate = this.props.selectedStartDate
                let defaultEndDate = this.props.selectedStartDate
                if(defaultStartDate){
                    // defaultStartDate = new Date(format(defaultStartDate,"yyyy-MM-dd")+" 00:00:00"); 
                    defaultStartDate = new Date(format(defaultStartDate,"yyyy-MM-dd")+"T00:00:00"); 
                    defaultEndDate = new Date(format(defaultEndDate,"yyyy-MM-dd")+"T08:00:00"); 
                }
                if(!this.state.selectedFromDate){
                    selectedFromDate = defaultStartDate
                    this.setState({selectedFromDate:selectedFromDate});
                }if(!this.state.selectedToDate){
                    selectedToDate = defaultEndDate
                    this.setState({selectedToDate:selectedToDate});
                }
                // selectedFromDate = format(selectedFromDate,'yyyy-MM-dd HH:mm:ss');
                selectedFromDate = format(selectedFromDate,'yyyy-MM-dd HH:mm:ss').replace(' ','T');
                selectedToDate = format(selectedToDate, 'yyyy-MM-dd HH:mm:ss').replace(' ','T');
                filtersSelected = 1;
            }
            if(this.state.crewId || this.state.locationId || this.state.departmentIds.length > 0 || this.state.skillIds.length > 0){
                filtersSelected = 1;
            }
            let shiftFromDate = 0; 
            let shiftEndDate = 0;
            let shiftFromDate_header = 0;
            let shiftEndDate_header = 0;
            if(this.state.includeDate){
                if(!this.props.selectedStartDate){
                    shiftFromDate = format(new Date(this.props.defaultStartDate), 'yyyy-MM-dd');
                    shiftFromDate_header = format(new Date(this.props.defaultStartDate), 'dd/MM/yyyy');
                    this.setState({selectedStartDate:this.props.defaultStartDate});
                }else{
                    shiftFromDate = format(new Date(this.props.selectedStartDate), 'yyyy-MM-dd');
                    shiftFromDate_header = format(new Date(this.props.selectedStartDate), 'dd/MM/yyyy');
                    this.setState({selectedStartDate:this.props.selectedStartDate});
                }
                if(!this.props.selectedEndDate){
                    shiftEndDate = format(new Date(this.props.defaultEndDate), 'yyyy-MM-dd');
                    shiftEndDate_header = format(new Date(this.props.defaultEndDate), 'dd/MM/yyyy');
                    this.setState({selectedEndDate:this.props.defaultEndDate});
                }else{
                    shiftEndDate = format(new Date(this.props.selectedEndDate), 'yyyy-MM-dd');
                    shiftEndDate_header = format(new Date(this.props.selectedEndDate), 'dd/MM/yyyy');
                    this.setState({selectedEndDate:this.props.selectedEndDate});
                }   
                filtersSelected = 1; 
            }
            if(!this.props.actionNeeded){
                this.props.timeSheetDateHeader("("+shiftFromDate_header+" - "+shiftEndDate_header+")");
            }
            // this.props.setSelectedDate(this.state.selectedStartDate,this.state.selectedEndDate);
            let filterData = {crewId:this.state.crewId,locationId:this.state.locationId,departmentIds:this.state.departmentIds,skillIds:this.state.skillIds,eventIds:arrEventIds, in_out:in_out, selectedFromDate:selectedFromDate, selectedToDate:selectedToDate, selHoursType:selHoursType, startTime:startTime, endTime:endTime, filtersSelected:filtersSelected, shiftFromDate:shiftFromDate,shiftEndDate:shiftEndDate}; 
            
            this.props.applyFilters(filterData); 
        }
    }

    componentDidUpdate (prevProps) {
        if(this.props.filterClicked!==prevProps.filterClicked && this.state.eventsListCalled===0) {
            this.setState({eventsListCalled:1})
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                let dataObj = {affiliateIds:[Number(storageData.client_default_affiliate_id)]}; 
                this.props.timesheetFilterEventsListAction(dataObj); 
                this.props.timesheetFilterLocationsListAction(); 
                this.props.timesheetFilterSkillsListAction(); 
                this.props.timesheetFilterDepartmentsListAction(); 
                this.props.timesheetFilterCrewsListAction(); 
            }
            else {
                let dataObj = {}; 
                this.props.timesheetFilterEventsListAction(dataObj);
                this.props.timesheetFilterLocationsListAction();
                this.props.timesheetFilterSkillsListAction(); 
                this.props.timesheetFilterDepartmentsListAction(); 
                this.props.timesheetFilterCrewsListAction();   
            }
        } 

        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(); 
        }

        const {timesheetFilterSkillsList,timesheetFilterDepartmentsList,timesheetFilterCrewsList,timesheetFilterLocationsList,timesheetFilterStatus,timesheetFilterActivity,timesheetFilterEventsList,timesheetFilterErrorData,filterActivity,filterStatus,filterErrorData} = this.props; 

        if (timesheetFilterActivity && timesheetFilterActivity !== prevProps.timesheetFilterActivity) {
            let arrTmp = [];
            arrTmp = (timesheetFilterActivity && timesheetFilterActivity.length) ? timesheetFilterActivity.split('~~') : [];
            let actString = arrTmp[0]; 
            if(actString===types.TIMESHEET_FILTER_EVENTS_SUCCESS) { 
                let eventsOptions = [];  
                if(timesheetFilterStatus===200) {
                    if(timesheetFilterEventsList && Array.isArray(timesheetFilterEventsList)){
                        timesheetFilterEventsList.forEach(item => {             
                            eventsOptions.push({id:item.event_id, name:item.event_title});
                        });            
                    }
                }
                else {
                    console.log('Events List Error '+JSON.stringify(timesheetFilterErrorData)); 
                }
                this.setState({eventsOptions}); 
            }
            else if(actString===types.TIMESHEET_FILTER_LOCATION_SUCCESS){
                    let locationOptions = [];
                    if(timesheetFilterStatus===200) {
                    if(timesheetFilterLocationsList && Array.isArray(timesheetFilterLocationsList)){
                        timesheetFilterLocationsList.forEach(item => {             
                            locationOptions.push({id:item.location_id, name:item.location});
                        });            
                    }
                }
                else {
                    console.log('Location List Error '+JSON.stringify(timesheetFilterErrorData)); 
                }
                this.setState({locationOptions});
            }
            else if(actString===types.TIMESHEET_FILTER_CREW_SUCCESS){
                    let crewNameOptions = [];
                    if(timesheetFilterStatus===200) {
                    if(timesheetFilterCrewsList && Array.isArray(timesheetFilterCrewsList)){
                        timesheetFilterCrewsList.forEach(item => {             
                            crewNameOptions.push({id:item.crew_id, name:item.crew_name});
                        });            
                    }
                }
                else {
                    console.log('crews List Error '+JSON.stringify(timesheetFilterErrorData)); 
                }
                this.setState({crewNameOptions});
            }
            else if(actString===types.TIMESHEET_FILTER_SKILL_SUCCESS){
                    let skillData = [];
                    if(timesheetFilterStatus===200) {
                    if(timesheetFilterSkillsList && Array.isArray(timesheetFilterSkillsList)){
                        timesheetFilterSkillsList.forEach(item => {             
                            skillData.push({value:item.skill_id, label:item.skill_name});
                        });            
                    }
                }
                else {
                    console.log('Skill List Error '+JSON.stringify(timesheetFilterErrorData)); 
                }
                this.setState({skillData});
            }
            else if(actString===types.TIMESHEET_FILTER_DEPARTMENT_SUCCESS){
                    let departmentData = [];
                    if(timesheetFilterStatus===200) {
                    if(timesheetFilterDepartmentsList && Array.isArray(timesheetFilterDepartmentsList)){
                        timesheetFilterDepartmentsList.forEach(item => {             
                            departmentData.push({value:item.department_id, label:item.department_name});
                        });            
                    }
                }
                else {
                    console.log('department List Error '+JSON.stringify(timesheetFilterErrorData)); 
                }
                this.setState({departmentData});
            }
        }
    }

    render(){

        let { selectedStartDate,selectedEndDate,dateValue,includeDate,skillData,departmentData,locationOptions,selectedLocation,crewNameOptions,selectedCrew,selectedEvent,eventsOptions, selectedFromDate, selectedToDate, selHoursType, startTime, endTime, selCheckinCheckout, formErrors} = this.state;
        let defaultStartDate = this.props.selectedStartDate
        let defaultEndDate = this.props.selectedStartDate
        if(defaultStartDate){
            // defaultStartDate = new Date(format(defaultStartDate,"yyyy-MM-dd")+" 00:00:00"); 
            defaultStartDate = new Date(format(defaultStartDate,"yyyy-MM-dd")+"T00:00:00");
            defaultEndDate = new Date(format(defaultEndDate,"yyyy-MM-dd")+"T08:00:00"); 
        }
        selectedFromDate = selectedFromDate ? selectedFromDate : defaultStartDate
        selectedToDate = selectedToDate ? selectedToDate : defaultEndDate
        let minDateVal = new Date(selectedFromDate); 

        let paddingTopPix = 250; // TO GIVE SPACE AT BOTTOM 

        selectedStartDate = this.props.selectedStartDate ? this.props.selectedStartDate : this.props.defaultStartDate;

        selectedEndDate = this.props.selectedEndDate ? this.props.selectedEndDate : this.props.defaultEndDate;

        return(
            <React.Fragment>
                <Form autoComplete="off">
                <div className="filter-category">                   
                        <div className="row"> 
                            {/* <div className="col-6"> <h4>
                                <div className="custom-checkbox" > 
                                    <input type="checkbox" id="includeDate" name="includeDate"  checked={includeDate} value={dateValue}  onChange={e => this.onDateCheck(e)} />
                                    <label className="checkbox" htmlFor="includeDate" ></label> 
                                    <label htmlFor="includeDate" >Shift Date From</label> 
                                </div></h4>
                            </div> */}
                            <div className="col-6"> <h4>Shift Date From</h4></div>
                            <div className="col-6"> <h4>Shift Date To</h4></div>
                        </div>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-6">
                                    <div className="calendar-input">  
                                        <DatePicker 
                                            selected={selectedStartDate}
                                            onChange={selected => this.onStartDateChange(selected)}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            // minDate={new Date()}
                                            fixedHeight   
                                            disabled={!includeDate}       
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="calendar-input ">  
                                        <DatePicker 
                                            selected={selectedEndDate}
                                            onChange={selected => this.onEndDateChange(selected)}
                                            name="endDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            minDate={new Date(selectedStartDate)}
                                            fixedHeight     
                                            disabled={!includeDate}         
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <div className="row margin-top-6">&nbsp;</div>
                <div className="filter-category margin-top-6">                   
                    <div className="row"> 
                        <div className="col-12"> 
                        <h4>{LBL_EVENT+' '+LBL_TITLE}</h4> 
                        <div className="form-group select-input">
                            <Typeahead
                                selected ={selectedEvent} 
                                id="events"
                                labelKey="name"
                                options={eventsOptions}
                                placeholder={"Choose "+' '+LBL_EVENT+"..."}
                                inputProps={{ name:'eventId', className:''}}
                                onChange={(s) => this.handleEventChange(s)}
                                onInputChange={this.handleRemoveEvent}
                            />  
                        </div>
                        </div>
                    </div>
                </div>    

                <div className="filter-category">     
                    <div className="form-group">  
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_CHECKIN_CHECKOUT}</h4>  
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectCheckinOut(e)} name="selCheckinCheckout" value={selCheckinCheckout} >
                                        <option value="" >{LBL_SELECT}</option>
                                        <option value='checkin' >{LBL_CHECKIN}</option> 
                                        <option value='checkout' >{LBL_CHECKOUT}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>   

                        {/* {this.state.selCheckinCheckout.length > 1 && <div>&nbsp; </div> } */}

                        {this.state.selCheckinCheckout.length > 1 && <div className="row"> 
                            <div className="col-6 padding-top-10"> <h4>{LBL_FROM_TIME}</h4></div>
                            <div className="col-6 padding-top-10"> <h4>{LBL_TO_TIME}</h4></div>
                        </div>}

                        {this.state.selCheckinCheckout.length > 1 && <div className="row">
                            <div className="col-6">
                                <div className="calendar-input"> 
                                <DateTimePicker
                                    inputProps={{ readOnly:true, 
                                        style: { width: 200 }, className:formErrors.selectedFromDate.length > 0 ? 'input-error' : ''
                                    }}
                                    dateFormat="DD/MM/YYYY"
                                    timeFormat="HH:mm"
                                    timeConstraints={ ENUM_MM5 } 
                                    fixedHeight
                                    name="startDate"
                                    value={selectedFromDate}
                                    onChange={selected => this.onDateFromChange(selected)}
                                />
    

                                    {/*  
                                        selected={selectedFromDate}
                                        onChange={selected => this.onDateFromChange(selected)}
                                        name="startDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="Select"
                                        //maxDate={new Date()}
                                        // minDate={new Date()}
                                        fixedHeight   
                                        disabled={!includeDateCheckin}       
                                    /> */}
                                </div>
                            </div>
                               
                            <div className="col-6">
                                <div className="form-group">
                                    <div className="calendar-input ">  
                                        <DateTimePicker
                                            inputProps={{ readOnly:true, 
                                                style: { width: 200 }, className:formErrors.selectedToDate.length>0?'input-error':'', minDate:minDateVal 
                                            }}
                                            dateFormat="DD/MM/YYYY"
                                            timeFormat="HH:mm"
                                            timeConstraints={ ENUM_MM5 } 
                                            fixedHeight
                                            name="endDate"
                                            value={selectedToDate}
                                            onChange={selected => this.onDateToChange(selected)} 
                                            minDate={minDateVal} 
                                            
                                        />
                                        {/* 
                                        <DatePicker 
                                            selected={selectedToDate}
                                            onChange={selected => this.onDateToChange(selected)}
                                            name="endDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Select"
                                            //maxDate={new Date()}
                                            minDate={new Date(selectedFromDate)}
                                            fixedHeight     
                                            disabled={!includeDateCheckin}         
                                        /> */}
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
                
                <div className="filter-category">     
                    <div className="form-group">              
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_SELECT_HOURS}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectHoursType(e)} name="selHoursType" value={selHoursType}  >
                                        <option value="" data-loc="">{LBL_SELECT}</option>
                                        <option value='scheduled' >{LBL_SCHEDULED_HOURS}</option> 
                                        {/* <option value='actual' >{LBL_ACTUAL_HOURS}</option> COMMENTED ON 18 MARCH 2021 ON CUSTOMER REQUEST  */}
                                        <option value='over_time' >{LBL_OT_HOURS}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>
                        {selHoursType!=='' && <div className="row padding-top-10">     
                            <div className="col-6">
                                <div className="time-input ">
                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'startTime'}}  value={startTime} onChange={selected=>this.onStartTimeChange(selected)} onBlur={selected=>this.onStartTimeBlur(selected)} timeConstraints={ ENUM_MM5 } />
                                </div>
                            </div> 
                            <div className="col-6">
                                <div className={formErrors.endTime.length > 0 ? "time-input input-error" : 'time-input input-error'} >
                                <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', className:formErrors.endTime.length >0 ? "input-error" : ''}} value={endTime} onChange={selected=>this.onEndTimeChange(selected)} onBlur={selected=>this.onEndTimeChange(selected)} timeConstraints={ ENUM_MM5 }  />
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>    
                <div className="filter-category">
                    <div className="form-group">                      
                        <div className="row"> 
                            <div className="col-12"> 
                            <h4>{LBL_CREW}</h4>            
                            <Typeahead
                                selected ={selectedCrew}
                                id="crew-name"
                                labelKey="name"
                                options={crewNameOptions}
                                placeholder={LBL_CHOOSE_CREW}
                                inputProps={{ name:'crewName',className:''}}
                                onChange={(s) => this.handleCrewNameChange(s)}
                                onInputChange={this.handleRemoveCrewName} > 
                            </Typeahead>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="filter-category"> 
                    <div className="form-group">                  
                        <div className="row"> 
                            <div className="col-12"> 
                            <h4>{LBL_LOCATION}</h4>            
                            <Typeahead
                                selected ={selectedLocation}
                                id="location"
                                labelKey="name"
                                options={locationOptions}
                                placeholder={LBL_CHOOSE_LOCATION}
                                inputProps={{ name:'location',className:''}}
                                onChange={(s) => this.handleLocationChange(s)}
                                onInputChange={this.handleRemoveLocation} > 
                            </Typeahead>
                            </div>
                        </div>
                    </div>
                </div>
                
                {!this.props.isClientPage && <div className="filter-category"> 
                    <div className="form-group"> 
                        <div className="row"> 
                            <div className="col-12">
                            <h4>{LBL_DEPARTMENTS}</h4>
                            <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                    <CustomMultiSelect data={departmentData}  onChange={selected =>this.onDepartmentDataChange(selected)} isTextBox={false} needSelectAll={true} />
                                </div>
                            </div>
                            </div>   
                        </div>  
                    </div>  
                </div>}

                <div className="filter-category"> 
                    <div className="form-group"> 
                        <div className="row"> 
                            <div className="col-12">
                            <h4>{LBL_SKILLS}</h4>
                            <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                    <CustomMultiSelect data={skillData}  onChange={selected =>this.onSkillDataChange(selected)} isTextBox={false} needSelectAll={true} />
                                </div>
                            </div>
                            </div>   
                        </div> 
                    </div> 
                </div>
                <div>&nbsp; </div>
                {/* {formErrors.commonErr.length > 1 && <div className="text-red"><small>{formErrors.commonErr}</small></div>}
                 */}

                <div style={{paddingTop:paddingTopPix}}></div>
            </Form>    
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => { 
    return {
        timesheetFilterStatus: state.timesheet.timesheetFilterStatus,
        timesheetFilterActivity: state.timesheet.timesheetFilterActivity,
        timesheetFilterEventsList: state.timesheet.timesheetFilterEventsList,
        timesheetFilterCrewsList: state.timesheet.timesheetFilterCrewsList,
        timesheetFilterLocationsList: state.timesheet.timesheetFilterLocationsList,
        timesheetFilterSkillsList: state.timesheet.timesheetFilterSkillsList,
        timesheetFilterDepartmentsList: state.timesheet.timesheetFilterDepartmentsList,
        timesheetFilterErrorData: state.timesheet.timesheetFilterErrorData,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        timesheetFilterEventsListAction:timesheetFilterEventsListAction,   
        timesheetFilterLocationsListAction:timesheetFilterLocationsListAction,   
        timesheetFilterDepartmentsListAction:timesheetFilterDepartmentsListAction,   
        timesheetFilterSkillsListAction:timesheetFilterSkillsListAction,   
        timesheetFilterCrewsListAction:timesheetFilterCrewsListAction,   
        timeSheetDateHeader:timeSheetDateHeader,   
    },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(FilterTimesheet);